<template>
  <!-- 우아한책임 > 정보보호 -->
  <section
    :id="hashTitle($t('informationProtection.compliance.title'))"
    v-bind="$attrs"
    class="article-anchor esg-protection"
  >
    <div class="esg-title-wrap">
      <h4 class="esg-title">{{ $t('menuSustainability.informationProtection') }}</h4>
    </div>

    <!-- 정보보호 및 개인정보보호 규정 준수 -->
    <article class="esg-box policies">
      <div class="esg-box-image">
        <p>
          <picture>
            <source media="(min-width: 750px)" srcset="../../../static/image/sustainability/img-protection-1@3x.png 3x">
            <source media="(max-width: 750px)" srcset="../../../static/image/sustainability/m/img-protection-1@3x.png 3x">
            <img src="../../../static/image/sustainability/img-protection-1.png" :alt="$t('compliance.declaration.name')">
          </picture>
        </p>
      </div>
      <html-view :value="$t('informationProtection.compliance.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <html-view :value="$t('informationProtection.compliance.paragraph')" class="paragraph" />
      </div>
    </article>

    <!-- 정보보호 인증 및 대외 협력 -->
    <article
      :id="hashTitle($t('informationProtection.externalCooperation.title'))"
      class="article-anchor esg-box external_cooperation"
    >
      <html-view :value="$t('informationProtection.externalCooperation.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <html-view :value="$t('informationProtection.externalCooperation.paragraph')" class="paragraph" />
      </div>
    </article>

    <!-- 정보보호 사고 예방과 대응 -->
    <article
      :id="hashTitle($t('informationProtection.prevention.title'))"
      class="article-anchor esg-box prevention"
    >
      <div class="esg-box-image">
        <picture>
          <source media="(min-width: 750px)" srcset="../../../static/image/sustainability/img-protection-2@3x.png 3x">
          <source media="(max-width: 750px)" srcset="../../../static/image/sustainability/m/img-protection-2@3x.png 3x">
          <img src="../../../static/image/sustainability/img-protection-2.png" :alt="$t('compliance.declaration.name')">
        </picture>
      </div>
      <html-view :value="$t('informationProtection.prevention.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <html-view :value="$t('informationProtection.prevention.paragraph')" class="paragraph" />
      </div>
    </article>

    <!-- 개인정보 처리절차 -->
    <article
      :id="hashTitle($t('informationProtection.processingProcedure.title'))"
      class="article-anchor esg-box processing_procedure"
    >
      <html-view :value="$t('informationProtection.processingProcedure.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <html-view :value="$t('informationProtection.processingProcedure.paragraph')" class="paragraph" />
        <ol class="list-number">
          <li class="list-number-item">
            <div class="list-number-heading">
              <span>
                <i class="number" />
                <strong>{{ $t('informationProtection.processingProcedure.list[0].title') }}</strong>
              </span>
            </div>
            <html-view :value="$t('informationProtection.processingProcedure.list[0].content')" class="list-number-content" />
          </li>
          <li class="list-number-item">
            <div class="list-number-heading">
              <span>
                <i class="number" />
                <strong>{{ $t('informationProtection.processingProcedure.list[1].title') }}</strong>
              </span>
            </div>
            <html-view :value="$t('informationProtection.processingProcedure.list[1].content')" class="list-number-content" />
          </li>
          <li class="list-number-item">
            <div class="list-number-heading">
              <span>
                <i class="number" />
                <strong>{{ $t('informationProtection.processingProcedure.list[2].title') }}</strong>
              </span>
            </div>
            <html-view :value="$t('informationProtection.processingProcedure.list[2].content')" class="list-number-content" />
          </li>
          <li class="list-number-item">
            <div class="list-number-heading">
              <span>
                <i class="number" />
                <strong>{{ $t('informationProtection.processingProcedure.list[3].title') }}</strong>
              </span>
            </div>
            <html-view :value="$t('informationProtection.processingProcedure.list[3].content')" class="list-number-content" />
          </li>
          <li class="list-number-item">
            <div class="list-number-heading">
              <span>
                <i class="number" />
                <strong>{{ $t('informationProtection.processingProcedure.list[4].title') }}</strong>
              </span>
            </div>
            <html-view :value="$t('informationProtection.processingProcedure.list[4].content')" class="list-number-content" />
          </li>
        </ol>
      </div>
    </article>
  </section>
</template>
<script>
import { hashTitle } from '@/util'
export default {
  methods: {
    hashTitle
  }
}
</script>
